import {ref,watch,toValue,onMounted,onBeforeUnmount} from 'vue';

// This is an account-specific UI permission, not a globally refreshable page query.
export function usePersonalPlantAccess(product:any,user:any){
 const access=ref({allowed:false});
 let stop:(()=>void)|undefined,version=0;
 onMounted(()=>{
  stop=watch([
   ()=>String(toValue(product)?.id||''),
   ()=>toValue(product)?.status,
   ()=>String(toValue(user)?.client_id||''),
  ],async([seed,status,owner],_previous,onCleanup)=>{
   const current=++version;access.value={allowed:false};
   if(status!=='noname'||!seed||!owner)return;
   const controller=new AbortController();onCleanup(()=>controller.abort());
   try{
    const result=await $fetch<{allowed:boolean}>('/api/catalog/personal-plant-access',{
     query:{seed_id:seed},signal:controller.signal,timeout:10000,retry:0,
    });
    if(current===version&&!controller.signal.aborted)access.value={allowed:result?.allowed===true};
   }catch{ /* Fail closed; a failed permission check must not start a retry loop. */ }
  },{immediate:true});
 });
 onBeforeUnmount(()=>{version++;stop?.();});
 return access;
}
